module.exports = __webpack_public_path__ + "static/create_application-be774ecaf09c9bc49b5dce8af010e21d.png";